import styled from 'styled-components';
import {
  TextField,
} from '@mui/material';

import { Wrapper } from '../../styles';

const StyledWrapper = styled(Wrapper)`
  overflow: auto;
`;

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: 15px 0;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const StyledTimeField = styled(TextField)`
  width: 265px;
  input {
    height: 45px;
  }
`;

const ButtonContainer = styled.div`
  margin: 10px 0;
  width: 250px !important;
`;

export {
  ContentWrapper,
  InputContainer,
  StyledTextField,
  ButtonContainer,
  StyledTimeField,
  StyledWrapper,
};
